import { render, staticRenderFns } from "./HomologarSubjects.vue?vue&type=template&id=284e3418"
import script from "./HomologarSubjects.vue?vue&type=script&lang=js"
export * from "./HomologarSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports